import { actionReducer } from "../../utils";
import { defaults, State } from "./model";

export default actionReducer<any, State>(defaults(), {
});
